export enum STATUS {
  ACTIVE = 'Active',
  BLOCKED = 'Blocked',
}

export type PromotionBanner = {
  id: string;
  title: string;
  description: string;
  image: string;
  status: STATUS;
  createdDate: string;
};

export type Advertisement = PromotionBanner & {
  link: string;
};
